var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#5f6368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120-358q0-10 4.5-18.5T137-390l49-35q23-17 52-14.5t50 22.5l197 191 145-116q11-8 23.5-13t26.5-5h120q17 0 28.5 11.5T840-320q0 17-11.5 28.5T800-280H680L535-164q-23 19-53.5 17.5T429-169L232-360l-49 35q-20 14-41.5 3T120-358Zm0-241q0-10 4-18t12-14l122-89q24-17 53-15t50 23l127 127 289-209q20-14 41.5-3t21.5 36q0 10-4.5 18T823-729L535-520q-24 17-53 15t-50-23L305-655l-122 89q-20 14-41.5 3T120-599Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineIcon);
export default __webpack_public_path__ + "static/media/line-icon.aa0258f0751db94056c723ab994fffcc.svg";
export { ForwardRef as ReactComponent };